<template>
  <header ref="anchor">
    <div class="desktop">
      <div class="desktop__main">
        <div class="desktop__main_wrapper">
          <h1 v-html-safe="content.title" class="desktop__main-title" />

          <div v-html-safe="content.subTitle" class="desktop__main-subTitle" />

          <div class="desktop__main-content">
            <h2 class="description">{{ content.description }}</h2>
          </div>
        </div>

        <div class="desktop__main_button">
          <div
            class="font-small button__presentation"
            @click="$emit('show-form-presentation')"
          >
            {{ content.buttonPresentation }}
          </div>
        </div>
      </div>

      <div class="desktop__picture">
        <div class="desktop__picture_wrapper">
          <img
            :src="`/img/${content.image}`"
            alt="header"
            class="desktop__picture-image"
          />
        </div>
      </div>
    </div>

    <div class="mobile">
      <div class="mobile__block mod-top">
        <div class="mobile__block-content">
          <h1 v-html-safe="content.title" class="title" />

          <div v-html-safe="content.subTitle" class="subTitle" />

          <h2 class="font-small description">{{ content.description }}</h2>

          <div class="mobile__main_button">
            <div
              class="font-small button__presentation"
              @click="$emit('show-form-presentation')"
            >
              {{ content.buttonPresentation }}
            </div>
          </div>
        </div>
      </div>

      <div class="mobile__block mod-bottom">
        <div class="mobile__block-image">
          <img :src="`/img/${content.image}`" alt="header" class="picture" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { headerBlock } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'HeaderComponent',
  mixins: [offsetMixin],
  data() {
    return {
      content: headerBlock,
    }
  },
}
</script>

<style lang="sass" scoped>
.desktop
  margin-top: 80px
  position: relative
  display: flex
  height: 55rem
  background: $textPrimary
  @media (max-width: 1279px)
    display: none
  &__left
    width: $desktopHorizontalPaddings
    border-right: 1px solid $buttonPrimary
    &-empty
      height: 67.6%
      border-bottom: 1px solid $buttonPrimary
    &-geometry
      height: 32.4%
      background-image: linear-gradient(to bottom right, transparent calc(50% - 1px), $buttonPrimary, transparent calc(50% + 1px))
      background-repeat: no-repeat
  &__main
    flex: 1
    width: 50%
    height: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    &_wrapper
      width: 100%
    &_button
      display: flex
      gap: 24px
      width: 100%
      padding: 4rem 5rem 4rem
      @media (min-width: 1280px) and (max-width: 1439px)
        padding: 4rem 0 4rem 5rem
    &-title
      display: flex
      align-items: flex-end
      padding: 0 5rem 0
      font-family: $primaryFont
      font-weight: 500
      font-size: 5.6rem !important
      color: $textWhite
      line-height: 6rem
      @media (min-width: 1440px) and (max-width: 1599px)
        padding: 0 4rem 0
        font-size: 9rem
      @media (min-width: 1280px) and (max-width: 1439px)
        padding: 0 5rem 0
        font-size: 8rem
    &-subTitle
      display: flex
      align-items: flex-end
      padding: 2rem 3.9rem 0 5rem
      font-family: $primaryFont
      font-weight: 500
      font-size: 4rem !important
      color: $buttonPrimary
      line-height: 4.8rem
      @media (min-width: 1280px) and (max-width: 1439px)
        padding: 2rem 3.9rem 0 5rem
    &-content
      display: flex
      justify-content: space-between
      padding: 2rem 3.9rem 0 5rem
      font-family: $secondaryFont
      color: $textLightWhite
      @media (min-width: 1280px) and (max-width: 1439px)
        padding: 2rem 3.9rem 0 5rem
      .description
        width: 80%
        font-weight: 400
        font-size: 1.8rem
        line-height: 2.4rem

      .button
        height: fit-content
  &__picture
    width: 50%
    height: 100%
    background-color: $buttonPrimary
    display: flex
    align-items: center
    justify-content: center
    @media (min-width: 1280px) and (max-width: 1599px)
      width: 50%

    &_wrapper
      width: 100%
      height: 100%
    &-image
      width: 100%
      height: 100%
      object-fit: cover
      object-position: center

.mobile
  display: block
  background: $textPrimary
  @media (min-width: 375px) and (max-width: 1279px)
    margin-top: 5.3rem
  @media (min-width: 1280px)
    display: none
    margin-top: 0
  &__main_button
    @media (max-width: 1279px)
      display: flex
      flex-direction: column
      gap: 20px
  &__block
    display: flex
    position: relative
    &-image
      overflow: hidden
      background-color: $buttonPrimary
      display: flex
      align-items: center
      justify-content: center
    &.mod-top
      height: 55rem
      border-bottom: 1px solid $buttonPrimary
    &.mod-bottom
      height: 26rem
    &-empty
      width: 10.9%
      border-right: 1px solid $buttonPrimary
    &-content, &-image
      flex: 1
      .picture
        object-fit: cover
        object-position: center
        width: 100%
        height: 100%

    &-content
      display: flex
      flex-direction: column
      justify-content: center
      padding: 0 1.4rem 3.1rem 2rem
      .title
        font-family: $primaryFont
        font-weight: 500
        font-size: 3.8rem
        line-height: 4.4rem
        color: $textWhite
        @media (min-width: 768px) and (max-width: 1279px)
          font-weight: 500
          font-size: 6rem !important
          line-height: 1.1
        @media (max-width: 768px)
          font-size: 3.4rem !important
      .subTitle
        font-family: $primaryFont
        font-weight: 500
        font-size: 3rem !important
        line-height: 3rem
        color: $buttonPrimary
        margin-top: 1.6rem
        @media (min-width: 768px) and (max-width: 1279px)
          font-weight: 500
          font-size: 4rem !important
          line-height: 3rem
      .description
        width: 46.5rem
        margin: 1.6rem 0 3rem
        font-weight: 300
        font-size: 1.4rem
        line-height: 2.0rem
        color: $textWhite
        @media (min-width: 768px) and (max-width: 1279px)
          font-weight: 300
          font-size: 1.4rem
          line-height: 2.0rem
        @media (max-width: 768px)
          width: 34rem

.button
  &__presentation
    min-width: 264px
    height: 5rem
    padding: 1rem 3rem
    border-radius: 50px
    font-weight: 400
    font-size: 1.8rem
    line-height: 2.4rem
    background-color: $buttonPrimary
    display: flex
    justify-content: center
    align-items: center
    color: $textWhite
    cursor: pointer
    transition: background-color 0.3s ease
    @media (max-width: 768px)
      height: auto

  &__demonstration
    min-width: 264px
    height: 5rem
    font-weight: 400
    font-size: 1.8rem
    line-height: 2.4rem
    padding: 1rem 3rem
    color: $buttonPrimary
    border: 1px solid $buttonPrimary
    display: flex
    justify-content: center
    align-items: center
    border-radius: 50px
    background-color: transparent
    cursor: pointer
    @media (max-width: 768px)
      height: auto
</style>
